import axios from '../axios';

const setSession = (authToken) => {
    if (authToken) {
        localStorage.setItem('authToken', authToken);
        axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    } else {
        localStorage.removeItem('authToken');
        delete axios.defaults.headers.common.Authorization;
    }
};

export default setSession;